"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const GaugeBar = _styledComponents.default.div`
	${({
  currentPercentage,
  gaugeSize,
  gaugeBarSize = '15px',
  gaugeBarColor = '#1A50FF',
  gaugeBarBaseColor = '#e8e8ea'
}) => `
          position: absolute;
          top: 0;
          left: 0;
          width: ${gaugeSize}px;
          height: ${gaugeSize}px;
          border-radius: 50%;
          box-sizing: border-box;
          border: ${gaugeBarSize} solid ${gaugeBarBaseColor};
          border-bottom-color: ${gaugeBarColor};
          border-right-color: ${gaugeBarColor};
          transform: rotate(${45 + currentPercentage * 1.8}deg);
		  transition: transform 1s ease;
`}
`;
var _default = exports.default = GaugeBar;
module.exports = exports.default;
module.exports.default = exports.default;